import Button from "@components/atoms/button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";
import { ConnectedProps, connect } from "react-redux";

import { ActionWrapper, DialogTitle } from "./stripeModal.styled";
import { useNavigate } from "react-router-dom";

type ReduxProps = ConnectedProps<typeof connector>;

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StripeModal = ({
  handleClose,
  modalTitle,
  modalButtonText,
  isOpen,
}: ReduxProps & {
  modalTitle: string;
  modalButtonText: string;
  isOpen: boolean;
  handleClose: () => void;
}) => {

  const navigate = useNavigate();
  return (
    <>
      <Dialog
        open={isOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{modalTitle}</DialogTitle>
        <DialogActions>
          <ActionWrapper>
            <Button
              textColor={"#FFF"}
              text={modalButtonText}
              type={"button"}
              onClick={() => {
                navigate("/settings/transactions?txn_type=IN");
                handleClose();
              }}
            />
          </ActionWrapper>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapDispatchToProps = {
};

const connector = connect(undefined, mapDispatchToProps);
const StripeModalRedux = connector(StripeModal);

export { StripeModalRedux as StripeModal };
